import React, { useEffect } from "react";
import "./others.css";
import { ScreenHeader } from "react-library";
import { useNavigate, useParams } from "react-router-dom";
import { useRecoilState } from "recoil";
import { languageAtom } from "../../state/atoms/language.atom";
import { Routes } from "../../routes";
import { TLang } from "stencil-library";
import { t } from "../../services/locale.service";
import { updateUserLanguage } from "../../services/farm-user.service";

interface Language {
  label: string;
  value: string;
}

export const Languages: Language[] = [
  { label: "English", value: "en" },
  { label: "हिंदी", value: "hi" },
  { label: "मराठी", value: "ma" },
  { label: "ಕನ್ನಡ", value: "ka" },
  { label: "ગુજરાતી", value: "gu" },
  { label: "తెలుగు", value: "te" },
  { label: "தமிழ்", value: "ta" },
];

enum OtherOptionTypes {
  serviceRequest = "serviceRequest",
  language = "language",
}

const OthersScreen: React.FC = () => {
  const navigate = useNavigate();
  const { plotId, orgId } = useParams<{ plotId: string; orgId: string }>();
  const [selectedLanguage, setSelectedLanguage] = useRecoilState(languageAtom);


  
  const handleLanguageChange = async (newLang: string) => {
    const userId = localStorage.getItem("farmUserId");  
    if (userId) {
      try {
        const response = await updateUserLanguage(userId, newLang);
        console.log(response);
        if (response.message==="Success") {
          setSelectedLanguage(newLang);  
          navigate(Routes.unauthorized);  
        } else {
          console.error("Failed to update language:", response.message);
        }
      } catch (error) {
        console.error("Error updating language:", error);
      }
    } else {
      console.error("User ID not found in localStorage");
    }
  };



  const handleOptionClick = (optionId: string, data?: { lang?: string }) => {
    switch (optionId) {
    case OtherOptionTypes.language:
      if (data?.lang) {
        handleLanguageChange(data.lang as TLang);  
      }
      break;

    case OtherOptionTypes.serviceRequest:
      if (plotId && orgId) {
        navigate(Routes.tickets.replace(":plotId", plotId).replace(":orgId", orgId));
      } else {
        console.error("plotId or orgId is not available.");
      }
      break;

    default:
      break;
    }
  };

  useEffect(() => {
    const handleBack = () => window.history.back();
    window.addEventListener("back-icon-press", handleBack);
    return () => {
      window.removeEventListener("back-icon-press", handleBack);
    };
  }, []);

  return (
    <>
      <ScreenHeader screenName={t("Other")} />
      <div className="others-screen-container">
        <div className="others-screen-list-container">
          <ServiceRequestCard
            onClick={() => handleOptionClick(OtherOptionTypes.serviceRequest)}
          />
          <LanguageSelectorCard
            selectedLanguage={selectedLanguage}
            onChangeLanguage={(lang) =>
              handleOptionClick(OtherOptionTypes.language, { lang })
            }
          />
        </div>
      </div>
    </>
  );
};

// Service Request Card Component
const ServiceRequestCard: React.FC<{ onClick: () => void }> = ({ onClick }) => (
  <div className="others-screen-list-item-container" onClick={onClick}>
    <p>{t("Raise_Service_Request")}</p>
  </div>
);

// Language Selector Card Component
const LanguageSelectorCard: React.FC<{
  selectedLanguage?: string;
  onChangeLanguage: (lang: string) => void;
}> = ({ selectedLanguage, onChangeLanguage }) => (
  <div className="others-screen-list-item-container">
    <p>{t("Language")}</p>
    <select
      className="language-select"
      value={selectedLanguage}
      onChange={(e) => onChangeLanguage(e.target.value)}
    >
      <option value="">{t("Select")}</option>
      {Languages.map((lang) => (
        <option key={lang.value} value={lang.value}>
          {lang.label}
        </option>
      ))}
    </select>
  </div>
);

export default OthersScreen;
